
import React, { useRef, useEffect, useState } from 'react'
import '../styleCss/a.css'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import TypingText from './TypingText';
import SEO from '../SEO';
import Header from './Header';
import Footer from './Footer';

const PrivacyPolicy = () => {

  const [showContactInfo, setShowContactInfo] = useState();
  useEffect(() => {
    window.scrollTo(0, 0); // scrolls to top when component mounts
  }, []);

  useEffect(() => {
    const navbar = document.getElementById("navbar");

    const media = window.matchMedia("(width <= 1024px)");

    function updateNavbar(e) {
      const isMobile = e.matches;
      const menu_div = document.getElementById("mob_menu");
      if (isMobile) {
        menu_div.style.display = "block";
        navbar.setAttribute("inert", "");
      } else {
        menu_div.style.display = "none";
        navbar.removeAttribute("inert");
      }
    }

    media.addEventListener("change", updateNavbar);
    updateNavbar(media);

    return () => media.removeEventListener("change", updateNavbar);
  }, []);




  const openSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");


    navbar.classList.add("show");
    openButton.setAttribute("aria-expanded", "true");
    openButton.style.display = "none";
    navbar.removeAttribute("inert");
  };

  const closeSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");

    if (openButton.getAttribute('aria-expanded') === 'true') {


      navbar.classList.remove('show');
      openButton.setAttribute('aria-expanded', 'false');
      openButton.setAttribute('style', 'display: block;');
      navbar.setAttribute('inert', '');

    }
  };




  return (

    <div className='w-screen h-full'>
      <Header></Header>




      <div id="overlay" aria-hidden="true"></div>

      <div className="tchead">
        <div className="tcinhead">
          <div style={{ textAlign: "center" }}>
            <h1>
            <b>
              Privacy Policy
              Effective Date: June 2, 2025</b>
              </h1>
              <br /><br />
          </div>
          Welcome to AlgoController.com. We value your privacy and are committed to safeguarding your personal information. This Privacy Policy explains how we collect, use, disclose, and protect your data when you use our website or services.
          <br /><br />
          <b>1. Who We Are</b><br />
          &nbsp;&nbsp;&nbsp; * This website, AlgoController.com ("Website", "we", "us", or "our") is owned and operated by Raja Yadav, and is designed for users in India interested in algorithmic trading tools and market automation services.
          <br /><br />
          <b>2. Scope of This Policy</b><br />
          &nbsp;&nbsp;&nbsp; * This Privacy Policy applies to all visitors, users, and subscribers of our services via the Website. By accessing or using the Website, you agree to this Policy. If you do not agree, please do not use our services.
          <br /><br />
          <b>3. What Personal Data We Collect</b><br />
          &nbsp;&nbsp;&nbsp; * We may collect the following information:
          <br />
          &nbsp;&nbsp;&nbsp; * Identity & Contact Data: Name, email, phone number, etc.
          <br />
          &nbsp;&nbsp;&nbsp; * Technical Data: IP address, browser type, device info, OS, etc.
          <br />
          &nbsp;&nbsp;&nbsp; * Usage Data: Pages visited, features used, interaction timestamps.
          <br />
          &nbsp;&nbsp;&nbsp; * Transactional Data: Services used, payment history, subscription data.
          <br />
          &nbsp;&nbsp;&nbsp; * Communications: Emails or inquiries sent to us, support tickets, etc.
          <br />
          &nbsp;&nbsp;&nbsp; * We do not collect sensitive data such as Aadhaar numbers, biometric info, or health-related data unless required by law and with your explicit consent.
          <br /><br />
          <b>4. How We Collect Data</b><br />
          Your data may be collected:
          <br />
          &nbsp;&nbsp;&nbsp; * When you fill out forms, sign up, or subscribe.
          <br />
          &nbsp;&nbsp;&nbsp; * When you contact us via email or chat.
          <br />
          &nbsp;&nbsp;&nbsp; * Through cookies and similar technologies.
          <br />
          &nbsp;&nbsp;&nbsp; * From third-party analytics tools like Google Analytics.
          <br /><br />
          <b>5. Cookies & Tracking Technologies</b><br />
          We use cookies to:<br />

          &nbsp;&nbsp;&nbsp; * Improve website performance and user experience.
          <br />
          &nbsp;&nbsp;&nbsp; * Remember user preferences.
          <br />
          &nbsp;&nbsp;&nbsp; * Monitor user traffic and behavior for analytics.
          <br />
          &nbsp;&nbsp;&nbsp; * You can manage or block cookies via your browser settings.
          <br /><br />
          <b>6. How We Use Your Data</b><br />
          We use your information for:
          <br />
          &nbsp;&nbsp;&nbsp; * Service delivery and account management.
          <br />
          &nbsp;&nbsp;&nbsp; * Customer support and resolving issues.
          <br />
          &nbsp;&nbsp;&nbsp; * Sending updates, newsletters, and offers (with opt-out option).
          <br />
          &nbsp;&nbsp;&nbsp; * Legal compliance and fraud prevention.
          <br />
          &nbsp;&nbsp;&nbsp; * Website analytics and improvements.
          <br /><br />
          <b>7. Data Sharing</b><br />
          &nbsp;&nbsp;&nbsp; * We do not sell your personal data. We may share data with:
          <br />
          &nbsp;&nbsp;&nbsp; * Legal authorities if required under applicable laws.
          <br />
          &nbsp;&nbsp;&nbsp; * Third parties with your explicit consent.
          <br /><br />
          <b>8. Data Retention</b><br />
          We retain your information only as long as necessary for:
          <br />
          &nbsp;&nbsp;&nbsp; * Service delivery.
          <br />
          &nbsp;&nbsp;&nbsp; * Legal obligations.
          <br />
          &nbsp;&nbsp;&nbsp; * Auditing, taxation, or regulatory needs.
          <b /><br />
          <b>9. Your Rights</b><br />
          You have the right to:
          <br />
          &nbsp;&nbsp;&nbsp; * Access and review your data.
          <br />
          &nbsp;&nbsp;&nbsp; * Request corrections or deletions.
          <br />
          &nbsp;&nbsp;&nbsp; * Withdraw consent at any time.
          <br />
          &nbsp;&nbsp;&nbsp; * Object to certain types of processing.
          <br />
          &nbsp;&nbsp;&nbsp; * Opt out of marketing communications.
          <br />
          &nbsp;&nbsp;&nbsp; * For requests, contact: <b>support@algocontroller.com</b>
          <br /><br />
          <b>10. Data Security</b><br />
          &nbsp;&nbsp;&nbsp; * We employ industry-standard security protocols and encryption (HTTPS) to protect your data. While no system is entirely secure, we take all reasonable measures to prevent unauthorized access.
          <br /><br />
          <b>11. Children’s Privacy</b><br />
          &nbsp;&nbsp;&nbsp; * We do not knowingly collect personal data from children under the age of 18. If you believe a child has provided us data, please contact us for prompt deletion.
          <br /><br />
          <b>12. Policy Updates</b><br />
          &nbsp;&nbsp;&nbsp; * We may update this Privacy Policy periodically. The revised version will be posted on this page with an updated effective date. Your continued use of the Website implies your acceptance of any updates.
          <br /><br />
          <b>13. Contact Us</b><br />
          &nbsp;&nbsp;&nbsp; * For any questions or concerns regarding this Privacy Policy, reach out to:
          <b>
            📧 Email: support@algocontroller.com
          </b>

          <br /><br />
        </div>
      </div>

      <br></br>


      <div id="myModal" className="modal">
        <div className="modal-content">
          <span className="close" >&times;</span>
          <h2>Hello!</h2>
          <p><b>We’re working hard behind the scenes to bring something great!</b><br />
            Some features and links will be available soon.<br />
            Thank you for your patience — our website is currently under construction.</p>
        </div>
      </div>

      <br /><br />
      

      <Footer></Footer>
     

    </div>

  )
}

export default PrivacyPolicy